import React, { useEffect, useState } from 'react';
import axiosConfig from '../axiosConfig';
import { useParams } from 'react-router-dom';
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';

const ChannelSubscriptionHistory = () => {
    const { channelId } = useParams();
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchChannelHistory = (channelId) => {
        setLoading(true);
        setError(null);

        axiosConfig.get(`/channel/subscription/history/${channelId}`)
            .then((res) => {
                setHistoryData(res.data);
                //console.log("kire cvai");
            })
            .catch((err) => {
                if (err.response && err.response.data && err.response.data.message) {
                    setError(err.response.data.message);
                } else {
                    setError("An error occurred while fetching history.");
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        //console.log("kire cvai");
        //console.log(channelId);
        if (channelId) {
            //console.log("kire vai");
            fetchChannelHistory(channelId);
        }
    }, [channelId]);

    const modify_date = (date) => {
        return new Date(date).toLocaleString(undefined, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    return (
        <div><Header title="Channel Subscriptions History" />
            <MainMenu menu="userdatafilter" />

            {/* <div class="app-content content"> */}
            <div class=" content">
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >

                    <div class="content-body">

                        <div class="card">
                            <br />
                            <div class="row card-content collapse show">


                                {loading && <div className="text-info">Loading history...</div>}
                                {error && <div className="text-danger">{error}</div>}

                                {!loading && !error && historyData.length === 0 && (
                                    <div className="text-warning">No history data available.</div>
                                )}

                                {!loading && !error && historyData.length > 0 && (
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>#ID</th>
                                                    <th>Channel Name</th>
                                                    <th>Created At</th>
                                                    <th>Filter Name</th>
                                                    <th>Channel Name</th>
                                                    <th>Start</th>
                                                    <th>Finish</th>
                                                    <th>Remarks</th>
                                                    <th>Added By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyData.map((log, index) => (
                                                    <tr key={log.id}>
                                                        <td>{log.id}</td>
                                                        <td>{log.channel.channel_name}</td>
                                                        <td>{modify_date(log.created_at)}</td>
                                                        <td>{log.filter_name}</td>
                                                        <td>{log.channel.channel_name}</td>
                                                        <td>{log.start}</td>
                                                        <td>
                                                            {log.finish
                                                                ? log.finish
                                                                : <span className="badge badge-success">Continue</span>
                                                            }
                                                        </td>
                                                        <td>{log.remarks}</td>
                                                        <td>{log.app_user?.name || 'N/A'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                            </div></div>
                    </div>

                </div>
            </div>
        </div>

    );
};

export default ChannelSubscriptionHistory;